import { updateArticle } from "../../../store/articles/ArticlesApi";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditPriceTextField from "../../EditArticle/EditPriceTextField";
import React from "react";
import withIntl from "../../../utils/withIntl";

function PriceFieldArticle(props) {
  return (
    <EditPriceTextField
      inputProps={props.inputProps}
      disabled={props.disabled}
      variant={"standard"}
      authorizationField={"article.price"}
      label={props.intl.formatMessage({ id: "price" })}
      price={
        typeof props.article.meta_json?.originalPrice === "number"
          ? props.article.meta_json?.originalPrice
          : props.article.price
      }
      onBlur={
        props.onBlur
          ? props.onBlur
          : (value, setBeginValue) => {
              if (value == null) {
                value = 0;
              }
              if (typeof props.article.meta_json?.originalPrice === "number") {
                updateArticle(articlesStore.merchantId, props.article, {
                  meta_json: { originalPrice: value },
                }).then((article) => {
                  setBeginValue(value);
                  if (props.setArticle) {
                    props.setArticle(article);
                  }
                });
              } else {
                updateArticle(articlesStore.merchantId, props.article, { price: value }).then((article) => {
                  setBeginValue(value);
                  if (props.setArticle) {
                    props.setArticle(article);
                  }
                });
              }
            }
      }
    />
  );
}

export default withIntl(PriceFieldArticle);
